/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import ProfileModelPopup from "../../components/modelpopup/ProfileModelPopup";
import moment from "moment";
import {
  Applogo,
  Avatar_02,
  Avatar_01,
  headerlogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";
import { FaRegBell, FaRegComment } from "react-icons/fa";
import ProfileMenu from "./ProfileMenu"; // Import the ProfileMenu component

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const profilePic = localStorage.getItem('profilepic');
  const submitButtonRef = useRef(null);
  const businessdate = localStorage.getItem("posbusiness_date");
  const business_date = moment(businessdate).format("Do MMMM YYYY");

  const handleAppClick = (app) => {
 if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
switch (app) {
      case 'office':
        navigate('./employee-dashboard');
        break;
      case 'hms':
        navigate('/hospitality');
        break;
            case 'feedback':
        navigate('/feedback/feedback-settings');
        break;  
      case 'pos':
        alert('NetShine POS is available but not added to your plan. Please upgrade your plan.');
        break;
      default:
        break;
    }
  };

  const handleLogout = () => {
    setProfile(false);
localStorage.clear();
    sessionStorage.clear();
    navigate(baseUrl);
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };

  const handleProfile = () => {
    setProfile(true);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = localStorage.getItem("username");
  const useremail = localStorage.getItem("useremail");
  const gender = localStorage.getItem("gender");

  const handleAccountClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("/hospitality/account-setting");
    }, 300);
  };

  const handleApiClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("/api-settings");
    }, 300);
  };

  const handleManageOrgClick = () => {
    setProfile(false);
    setTimeout(() => {
      navigate("digital-menu/manage-property");
    }, 300);
  };

  const { t } = { t: (key) => key }; // Fallback translation function

  return (
    <div className="header" style={{ right: "0px" }}>
      <div className="header-left">
        <Link to="/digital-menu/" className="logo">
          <img src={headerlogo} width={150} height={50} alt="img" />
        </Link>
        <Link to="/digital-menu/" className="logo2">
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div>
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link>
      <div
        className="header-container"
        style={{
          display: "flex",
          justifyContent: "flex-end", // Align content to the right
          alignItems: "center",
          padding: "0 20px",
          height: "100%",
        }}
      >
      
        <div className="profile-section" style={{ textAlign: "right", marginLeft: "20px" }}>

          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              onClick={(event) => {
                event.preventDefault();
                handleProfile();
              }}
            >
              <span className="user-img me-1">
                <div className="profile-image">
                  <img
                    src={
                      profilePic && profilePic.trim() !== "" && profilePic !== "null"
                        ? `${cdnUrl}/${profilePic}`
                        : gender === "male"
                        ? Avatar_02
                        : Avatar_01
                    }
                    alt="User Avatar"
                    className="user-avatar"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </span>
            </Link>
          </li>
        </div>
      </div>
      <ProfileMenu
        isOpen={profile}
        onClose={() => setProfile(false)}
        profilePic={profilePic}
        gender={gender}
        ProfileName={ProfileName}
        useremail={useremail}
        flagImage={flagImage}
        handleLogout={handleLogout}
        handleAccountClick={handleAccountClick}
        handleApiClick={handleApiClick}
        handleManageOrgClick={handleManageOrgClick}
        handleAppClick={handleAppClick}
      />
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link className="dropdown-item" to="/profile">
            My Profile
          </Link>
          <Link className="dropdown-item" to="hospitality/manage-property">
            Settings
          </Link>
          <Link className="dropdown-item" to="#" onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;